import { getAnalytics, logEvent } from 'firebase/analytics';
import type { Events } from './events';
import { app } from '@/lib/firebase/client';
import { getCurrentUserId } from '@/actions/auth';

export const sendEvent = async (
  eventName: Events,
  params: { [key: string]: string | number | boolean } = {}
) => {
  const analytics = getAnalytics(app);
  const userId = params.userId || (await getCurrentUserId());
  logEvent(analytics, eventName, { userId, ...params });
};
